﻿import { nsMatrix } from "@/Namespaces";
import { ComboboxEditor, ComboboxEditorOptions, EditorProps, tryGetText } from "@serenity-is/corelib";

export class ColumnsKeyEditor extends ComboboxEditor<any, any> {
    static override[Symbol.typeInfo] = this.registerEditor(nsMatrix);

    constructor(opt: EditorProps<ComboboxEditorOptions>) {
        super({...opt, autoComplete: true});

        const symbol = Object.getOwnPropertySymbols(window).find(x => Symbol.keyFor(x) === "Serenity.scriptData");
        if (!symbol)
            return;

        const keys = Object.keys((window as any)?.[symbol] ?? {}).filter(x => x.startsWith("Columns."));

        for (const key of keys) {
            const keyWithoutPrefix = key.substring(8) //"Columns."
            const name = tryGetText(`Db.${keyWithoutPrefix}.EntitySingular`);

            if (name) {
                this.addOption(keyWithoutPrefix, `${name} (${keyWithoutPrefix})`);
                continue;
            }

            this.addOption(keyWithoutPrefix, keyWithoutPrefix);
        }
    }
}